import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import BudgetUpdateModalUI from './BudgetUpdateModalUI.js'

class BudgetUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      successMsg: null,
      errorList: null,
      // update budget
      submitted: false,
      // budget name
      budgetName: this.props.budget.budgetName,
      budgetNameError: null,
    }
  }

  render() {
    return (
      <BudgetUpdateModalUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        // update mode
        updateMode={this.props.updateMode}
        // budget name
        budgetName={this.state.budgetName}
        onBudgetNameChange={(event) => {this.setState({budgetName: event.target.value})}}
        budgetNameError={this.state.budgetNameError}
        setBudgetNameError={(error) => {this.setState({budgetNameError: error})}}
        // form events
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        setErrorList={this.setErrorList}
        onCancelClick={this.onCancelClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/budgets/${this.props.match.params.budgetId}`,
      this.onSubmitCallback, {
        budgetName: this.state.budgetName,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
      switch(error.fieldName) {
        case 'budgetName':
          this.setState({budgetNameError: error.message})
          break;
        default:
      }
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (this.state.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null })
      }, 2000)
      this.props.onUpdateComplete(response.budget)
    }
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
    if (errorList && errorList.length > 0)
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
  }

  onCancelClick = () => {
    // reset everything
    this.setState({
      successMsg: null,
      errorList: null,
      budgetName: this.props.budget.budgetName,
      budgetNameError: null,
      submitted: false
    })
    this.props.onCancelClick()
  }

  getMessages(context) {
    let arr = [
      'c_update_budget',
      'c_update',
      'c_cancel',
      'c_budget_name',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('bdg_upd', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default withRouter(BudgetUpdateModalSF)
